<template>
	<div class="c-brands-page" v-if="isAuth" @scroll="onScroll">
		<DeactivatedEmptyState v-if="isDeactivated" title="Brand Tracker"></DeactivatedEmptyState>
		<Brands v-else ref="multi"></Brands>
	</div>
</template>

<script>
import Brands from '@swipekit/components/brands';
import DeactivatedEmptyState from '@/components/deactivated-empty-state.vue';

export default {
	components: {
		Brands,
		DeactivatedEmptyState,
	},

	computed: {
		isAuth: function () {
			return this.$store.getters['users/isAuth'];
		},
		isDeactivated: function () {
			return this.$store.getters['users/isTrialOver'];
		},
	},

	methods: {
		onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
			if (this.isDeactivated) {
				return;
			}
			let buffer = 200;
			if (scrollTop + clientHeight >= scrollHeight - buffer) {
				this.$refs.multi.onEnd();
			} else {
			}
		},
	},
};
</script>

<style lang="scss">
.c-brands-page {
	height: 100vh;
	position: relative;
	overflow-y: auto;
}
</style>
